import React from 'react';

import { Modal } from 'redpoints-front-components/index';

import { translate } from '../../../helpers/languageHelper';

const LinksManagementCloseModal = ({ onAccept, onCancel, visible }) => (
  <Modal
    visible={visible}
    okText={translate('actions.confirm')}
    onOk={onAccept}
    onCancel={onCancel}
  >
    {translate('tasks.links_management.modal.close_modal_label')}
  </Modal>
);

export default LinksManagementCloseModal;
